<!--
 * @Author: wang jun feng
 * @Date: 2019-07-22 10:03:11
 * @LastEditTime: 2020-07-18 16:01:54
 -->
<template>
  <div class="tip-box" :class="'tip-box-bg-' + type">
    <i class="icon el-icon-warning" v-if="type === 'error'"></i>
    <i class="icon el-icon-warning warning-icon" v-if="type === 'warning'"></i>
    <i class="icon" v-if="type === 'tip'" :style="{backgroundImage: `url(${syImgUrl}${iconPath})`}"></i>
    <i class="icon iconfont icon-bianzu3 success-icon" v-if="type === 'success'"></i>
    <p class="icon-text">
      <slot name="icon-text"></slot>
    </p>
    <div class="tip-content">
      <slot></slot>
    </div>
    <p class="close">
      <slot name="close-icon"></slot>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'import-tip',
    props: {
      iconPath: {
        type: String,
        default: '159428480909396423.svg'
      },
      // tip类型，默认tip黄色背景；可选值error，淡红色背景；可选值success，绿色背景
      type: {
        type: String,
        default: 'tip'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tip-box {
    min-height: 34px;
    line-height: 1;
    background-color: $tip-bg-color;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin: 4px 0;
    font-size: 0;
    border: 1px solid $tip-border-color;
    border-radius: 8px;
    display: flex;
    align-items: center;
    .icon-text {
      font-size: 12px;
      line-height: 20px;
      color: $content-color;
      display: inline-block;
      vertical-align: middle;
    }
    .tip-content {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
      color: $content-color;
      line-height: 1;
      width: calc(100% - 50px);
      p {
        line-height: 18px;
      }
    }
    .icon {
      display: inline-block;
      // background-image: url($img-url+'159428480909396423.svg');
      background-size: cover;
      width: 14px;
      height: 14px;
      font-size: 16px;
      vertical-align: top;
      margin-right: 10px;
    }
    .highlight {
      color: $tip-highlight-color;
    }
    a {
      color: $handle-color;
    }
    .close{
      float: right;
      margin-top: 5px;
      margin-left: 10px;
      width: 10px;
      height: 10px;
    }
  }
  .tip-box-bg-error {
    background-color: #FFF0EF;
    border-color: #FEDFDD;
    border-radius: 3px;
    color: #666666;
    i.icon {
      color: #DA0E0E;
    }
  }
  .tip-box-bg-success {
    border: 1px solid #CEF0BD;
    background: #E1F7D7;
    color: #666666;
    .success-icon {
      color: #5DCF25;
      font-size: 14px;
    }
  }
  .tip-box-bg-warning {
    border: 1px solid #E6A23C;
    background: #faecd8;
    color: #666666;
    margin: 0;
    border-radius: 0;
    .warning-icon {
      color: #E6A23C;
      font-size: 14px;
    }
  }
</style>
